import React, { InputHTMLAttributes, useState } from 'react';
import cn from 'classnames';
import styles from './TextInput.module.scss';

export default function TextInput({
  value,
  className,
  placeholder,
  onChange,
  onEnter,
  autoFocus,
  validateValue,
  invalidValueMsg,
  maxLength,
}: Omit<InputHTMLAttributes<HTMLInputElement>, 'value'> & {
  value: string;
  onEnter: () => void;
  validateValue: (value: string) => boolean;
  invalidValueMsg: string;
}) {
  const [invalid, setInvalid] = useState(false);

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && validateValue(value)) {
      onEnter();
    }
  };

  const checkValidity = () => {
    if (value !== '' && !validateValue(value)) {
      setInvalid(true);
    }
  };

  const resetValidity = () => {
    if (invalid) {
      setInvalid(false);
    }
  };

  return (
    <>
      <input
        className={cn(styles.textInput, className, invalid && styles.invalid)}
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onKeyDown={handleKeyDown}
        autoFocus={autoFocus}
        onBlur={checkValidity}
        onFocus={resetValidity}
        spellCheck={false}
        maxLength={maxLength}
      />
      {invalid && <div className={styles.invalidValueMsg}>{invalidValueMsg}</div>}
    </>
  );
}
